import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=6340a126"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6340a126')) {
      api.createRecord('6340a126', component.options)
    } else {
      api.reload('6340a126', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=6340a126", function () {
      api.rerender('6340a126', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/nomina/Index.vue"
export default component.exports